import { useContext } from 'react';
import type { Store } from '@wiztime/storage';
import { ServicesContext } from '../app/ServicesContext';
import type { Services } from '../app/services';

export function useServices(): Services {
  const services = useContext(ServicesContext);
  if (services === null) throw new Error('ServicesProvider is missing');
  return services;
}

export function useStore(): Store {
  return useServices().store;
}
